// projectsData.js
// Les métadonnées fixes (id, type, status, tech, images, links) sont statiques.
// Les textes (tagline, overview, sections) sont extraits de translations.js via useLang().

export const projectsMeta = [
  {
    id: "quickliv",
    badge: "Projet Académique / Academic Project",
    badgeFr: "Projet Académique",
    badgeEn: "Academic Project",
    type: "mobile",
    status: "completed",
    shortDescFr: "Application mobile de livraison alimentaire avec suivi temps réel et affectation de véhicule par IA",
    shortDescEn: "Food delivery mobile app with real-time tracking and AI vehicle assignment",
    tech: ["Flutter", "Dart", "Node.js", "Express", "PostgreSQL", "Socket.io", "Google Maps API", "Mistral AI", "Cloudinary", "JWT"],
    images: [
      require('./assets/logo_quickliv.jpg'),
      require('./assets/q1.jpg'),
      require('./assets/q2.jpg'),
      require('./assets/q3.jpg'),
      require('./assets/q4.jpg'),
      require('./assets/q5.jpg'),
      require('./assets/q6.jpg'),
      require('./assets/q7.jpg'),
      require('./assets/q8.jpg'),
      require('./assets/q9.jpg'),
      require('./assets/q10.jpg'),
      require('./assets/q11.jpg'),
    ],
    link: null,
    externalLink: null,
    stack: {
      mobile: ["Flutter", "Dart"],
      backend: ["Node.js", "Express", "PostgreSQL", "Socket.io"],
      services: ["Google Maps API", "Mistral AI", "Cloudinary", "JWT"],
    },
  },
  {
    id: "hestia",
    badgeFr: "Projet Professionnel",
    badgeEn: "Professional Project",
    type: "desktop",
    status: "completed",
    shortDescFr: "ERP de gestion de prestations & facility management, app desktop + site vitrine",
    shortDescEn: "ERP for property & facility management, desktop app + showcase website",
    tech: ["React", "Express.js", "PostgreSQL", "Proton (desktop)", "Next.js"],
    images: [
      require('./assets/property_2.jpg'),
      require('./assets/property_1.jpg'),
      require('./assets/property_3.jpg'),
      require('./assets/property_4.jpg'),
      require('./assets/property_5.jpg'),
      require('./assets/property_6.jpg'),
    ],
    link: null,
    externalLink: "https://hestiasolutionsdz.com",
    stack: {
      desktop: ["React", "Proton (desktop / .exe)"],
      backend: ["Express.js", "PostgreSQL"],
      web: ["Next.js"],
    },
  },
  {
    id: "taalim",
    badgeFr: "Projet Personnel",
    badgeEn: "Personal Project",
    type: "web",
    status: "completed",
    shortDescFr: "Application de gestion de séances de tutorat privé",
    shortDescEn: "Private tutoring session management app",
    tech: ["React", "Express", "SQLite"],
    images: [require('./assets/t1.jpg'),
        require('./assets/t2.jpg'),
        require('./assets/t3.jpg'),        require('./assets/t4.jpg'),
        require('./assets/t5.jpg'),
        require('./assets/t6.jpg'),
    ],
    link: null,
    externalLink: null,
    stack: {
      frontend: ["React"],
      backend: ["Express", "SQLite"],
    },
  },
  {
    id: "homelab",
    badgeFr: "Projet Personnel",
    badgeEn: "Personal Project",
    type: "infra",
    status: "in-progress",
    shortDescFr: "Ancien laptop reconverti en serveur Linux headless pour apprendre l'administration système par la pratique",
    shortDescEn: "Old laptop repurposed as a headless Linux server to learn system administration hands-on",
    tech: ["Linux (Debian)", "Docker", "Docker Compose", "Nginx", "UFW", "SSH"],
    images: [
      "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&q=80",
    ],
    link: null,
    externalLink: null,
    stack: {
      os: ["Debian (headless)"],
      containers: ["Docker", "Docker Compose"],
      networking: ["Nginx", "Let's Encrypt", "UFW"],
      access: ["SSH (key-only)"],
    },
  },
  {
    id: "pong",
    badgeFr: "Projet Académique",
    badgeEn: "Academic Project",
    type: "game",
    status: "completed",
    shortDescFr: "Réimagination moderne du jeu Pong classique",
    shortDescEn: "Modern reimagining of the classic Pong game",
    tech: ["C", "Raylib"],
    images: [
      require('./assets/pong-preview.png'),
      require('./assets/pong-mode.png'),
      require('./assets/pong-custom.png'),
    ],
    link: null,
    externalLink: null,
    stack: {
      language: ["C"],
      graphics: ["Raylib"],
    },
  },
  {
    id: "locaflow",
    badgeFr: "Projet Académique",
    badgeEn: "Academic Project",
    type: "desktop",
    status: "completed",
    shortDescFr: "Application de gestion de location de voitures",
    shortDescEn: "Car rental management application",
    tech: ["Java", "JavaFX", "MySQL"],
    images: [
      require('./assets/locaflow_dashboard.jpg'),
      require('./assets/locaflow_add_client.jpg'),
      require('./assets/locaflow_client.jpg'),
      require('./assets/locaflow_detail_vehicule.jpg'),
      require('./assets/locaflow_gestion_location.jpg'),
      require('./assets/locaflow_gestion_voiture.jpg'),
    ],
    link: null,
    externalLink: null,
    stack: {
      language: ["Java"],
      ui: ["JavaFX"],
      data: ["MySQL"],
    },
  },
  /*{
    id: "snake",
    badgeFr: "",
    badgeEn: "",
    type: "game",
    status: "completed",
    shortDescFr: "Snake classique réimplémenté pour explorer C++ et la conception POO",
    shortDescEn: "Classic Snake reimplemented to explore C++ and OOP design",
    tech: ["C++", "Raylib"],
    images: [
      require('./assets/snake-preview.png'),
      require('./assets/snake-game.png'),
    ],
    link: null,
    externalLink: null,
    stack: {
      language: ["C++"],
      graphics: ["Raylib"],
    },
  },*/
];

export const TYPE_META = {
  mobile:  { bg: "rgba(118,255,3,0.12)",   color: "#76ff03", labelFr: "Mobile",          labelEn: "Mobile" },
  desktop: { bg: "rgba(76,175,80,0.12)",   color: "#4caf50", labelFr: "Desktop",         labelEn: "Desktop" },
  web:     { bg: "rgba(100,200,255,0.12)", color: "#64c8ff", labelFr: "Web",             labelEn: "Web" },
  infra:   { bg: "rgba(255,180,50,0.12)",  color: "#ffb432", labelFr: "Infrastructure",  labelEn: "Infrastructure" },
  game:    { bg: "rgba(200,100,255,0.12)", color: "#c864ff", labelFr: "Jeu",             labelEn: "Game" },
};

export const isPlaceholder = (src) =>
  !src || (typeof src === "string" && src.startsWith("PLACEHOLDER"));